import React from "react";

import svg from "../../assets/images/icons/dropdown/dropdown_white.svg";

export const DropdownWhiteIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Dropdown"}
    />
);
